// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon-plus-gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon-statement.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_leave_note.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__buttonSecondary___qRZoq {
}

.styles__fullWidth___Yxvc4 {
  width: 100%;
}

.styles__contentContainer___flMYR {
  padding-bottom: 20px;
  padding-top: 20px;
  height: 100%;
}

.styles__oneThird___Lv1nj {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___Lv1nj:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___Lv1nj:last-child {
  margin-right: 0;
}

.styles__oneThird___Lv1nj:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___Lv1nj:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___Lv1nj {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___Lv1nj:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___Lv1nj:last-child {
    margin-right: 0;
}

.styles__oneThird___Lv1nj:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___Lv1nj:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__twoThird___aLE27 {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__twoThird___aLE27:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__twoThird___aLE27:last-child {
  margin-right: 0;
}

.styles__twoThird___aLE27:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__twoThird___aLE27:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__twoThird___aLE27 {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__twoThird___aLE27:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__twoThird___aLE27:last-child {
    margin-right: 0;
}

.styles__twoThird___aLE27:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__twoThird___aLE27:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__purchaseDate___JIGsS {
  color: textLight;
  font-size: 12px;
  font-weight: 400;
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.styles__assetHeader___uyb0M {
  background-color: #e7e7e7;
  padding: 16px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles__assetLeft___rw1Qf {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.styles__assetRight___mlSiT {
  text-align: right;
}

.styles__actions___gCOVt {
  display: grid;
  background: white;
  border-bottom: 0;
  /* stylelint-disable */
  grid-template-columns: repeat(2, 1fr);
  /* stylelint-enable */
  margin-bottom: 20px;
  border-radius: 3px;
}

.styles__actions___gCOVt :nth-child(odd) {
    border-right: 1px solid borderColor;
    border-radius: 3px 0 0 3px;
  }

.styles__actions___gCOVt :nth-child(even) {
    border-radius: 0 3px 3px 0;
  }

.styles__actionButton___GP6rb {
  display: flex;
  height: 50px;
  color: text;
  cursor: pointer;
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10%;
  width: 100%;
  box-shadow: none;
  border-bottom: 1px solid borderColor;
}

.styles__actionButton___GP6rb:hover {
    box-shadow: none;
    background: #f8f8f8;
  }

.styles__editButton___nyYFY {
}

.styles__editButton___nyYFY::before {
    content: '';
    height: 100%;
    width: 36px;
    margin-bottom: 2px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
  }

.styles__transactionButton___Tf1R4 {
}

.styles__transactionButton___Tf1R4::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

.styles__statementButton___yGrTc {
}

.styles__statementButton___yGrTc::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
.styles__editSubaccountButton___CzScG {
}
.styles__editSubaccountButton___CzScG::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

.styles__table___aC8nW {
  margin-top: 20px;
}

/* Attachments */

.styles__section___MIsnV {
}

.styles__sectionNoMargin___uOrxy {
}

.styles__buttons___sLIyW {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__spacer___e99JX {
  display: inline-block;
  width: 1em;
}

.styles__collapseRef___Tb1H7 {
}

.styles__collapseRef___Tb1H7[data-active='true'] .styles__collapseIcon___hpmXF {
      transform: rotate(180deg);
    }

.styles__leaveNoteIcon___SVfOZ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;
}

.styles__leaveNoteIcon___SVfOZ:hover {
    background-color: #e1dfe1;
  }

.styles__title___i1M3s {
  flex: 1;
}

.styles__titleSection___f5CyW {
  position: relative;
}

.styles__titleSection___f5CyW:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___f5CyW .styles__name___TDNSE {
    transition: all 0.25s;
  }

.styles__titleSection___f5CyW .styles__noName___wm1gZ {
    margin-top: 2px;
  }

.styles__cardMarginBot___eGTVX {
}

.styles__removeBtn___EzcZL {
}

.styles__cancelBtn___IHzvD {
}

.styles__docsWrapper___rGAH4 {
  background: white;
  border-radius: 0 0 3px 3px;
}

.styles__otherDocsRow___l_u5K {
  align-content: center;
  height: 70px;
  border-bottom: 1px solid borderColor;
  align-items: center;
  padding: 0 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.styles__otherDocsRow___l_u5K:last-child {
    border: none;
  }

.styles__otherDocsRow___l_u5K:hover div.styles__remove___pdsxJ {
      opacity: 1;
    }

.styles__noDocResults___HMzJj {
  color: textLight;
}

.styles__remove___pdsxJ {
  opacity: 0;
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___pdsxJ a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__cardMarginBot___eGTVX {
}

.styles__sectionTitle___jQFoz {
}

.styles__sectionNoMargin___uOrxy {
}

.styles__singleLine___Yop6o {
  display: flex;
  width: 100%;
  height: 30px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid borderColorLight;
}

.styles__singleLine___Yop6o div.styles__label___sMwdY {
    font-size: 14px;
    color: text;
    opacity: 0.9;
  }

.styles__logSection___nUAqa {
  margin-left: 40px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/Main/styles.css"],"names":[],"mappings":"AAEA;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EAEjB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AAUpB;;AARE;IACE,mCAAmC;IACnC,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AAMtC;;AAJE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;AAGF;AAaA;;AAVE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;EACvB;;AAGF;AAMA;;AAHE;IACE,yDAAsD;EACxD;;AAGF;AAMA;;AAHE;IACE,yDAAsD;EACxD;AAEF;AAMA;AAHE;IACE,yDAAiD;EACnD;;AAGF;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;AAEA;;AAEA;AAEA;;AAEA;EACE,mBAAmB;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;EACE,yDAAuD;EACvD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;AAKb;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,OAAO;AACT;;AAEA;EAEE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AAWb;;AATE;IACE,YAAY;EACd;;AAGE;MACE,UAAU;IACZ;;AAIJ;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAO3C;;AALE;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;AAGF;EACE,iBAAiB;AACnB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-bottom: 20px;\n  padding-top: 20px;\n  height: 100%;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.twoThird {\n  lost-column: 2/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.purchaseDate {\n  color: textLight;\n  font-size: 12px;\n  font-weight: 400;\n  margin-top: 4px;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n\n.assetHeader {\n  background-color: #e7e7e7;\n  padding: 16px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.assetLeft {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n}\n\n.assetRight {\n  text-align: right;\n}\n\n.actions {\n  display: grid;\n  background: white;\n  composes: card from helpers;\n  border-bottom: 0;\n  /* stylelint-disable */\n  grid-template-columns: repeat(2, 1fr);\n  /* stylelint-enable */\n  margin-bottom: 20px;\n  border-radius: 3px;\n\n  :nth-child(odd) {\n    border-right: 1px solid borderColor;\n    border-radius: 3px 0 0 3px;\n  }\n\n  :nth-child(even) {\n    border-radius: 0 3px 3px 0;\n  }\n}\n\n.actionButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  cursor: pointer;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 10%;\n  width: 100%;\n  box-shadow: none;\n  border-bottom: 1px solid borderColor;\n\n  &:hover {\n    box-shadow: none;\n    background: #f8f8f8;\n  }\n}\n\n.editButton {\n  composes: actionButton;\n\n  &::before {\n    content: '';\n    height: 100%;\n    width: 36px;\n    margin-bottom: 2px;\n    background-image: url('styles/img/icon_edit.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n  }\n}\n\n.transactionButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-plus-gray.png');\n  }\n}\n\n.statementButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-statement.png');\n  }\n}\n.editSubaccountButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon_edit.png');\n  }\n}\n\n.table {\n  margin-top: 20px;\n}\n\n/* Attachments */\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.buttons {\n  align-items: center;\n  composes: section from helpers;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.leaveNoteIcon {\n  background-image: url('styles/img/icon_leave_note.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    background-color: #e1dfe1;\n  }\n}\n\n.title {\n  flex: 1;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n\n.docsWrapper {\n  composes: flexColumn from helpers;\n  background: white;\n  border-radius: 0 0 3px 3px;\n}\n\n.otherDocsRow {\n  align-content: center;\n  height: 70px;\n  border-bottom: 1px solid borderColor;\n  align-items: center;\n  padding: 0 20px;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  width: 100%;\n\n  &:last-child {\n    border: none;\n  }\n\n  &:hover {\n    div.remove {\n      opacity: 1;\n    }\n  }\n}\n\n.noDocResults {\n  composes: sectionNoMargin;\n  color: textLight;\n}\n\n.remove {\n  opacity: 0;\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 30px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid borderColorLight;\n\n  div.label {\n    font-size: 14px;\n    color: text;\n    opacity: 0.9;\n  }\n}\n\n.logSection {\n  margin-left: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"buttonSecondary": `styles__buttonSecondary___qRZoq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["buttonSecondary"]}`,
	"fullWidth": `styles__fullWidth___Yxvc4`,
	"contentContainer": `styles__contentContainer___flMYR ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content-container"]}`,
	"oneThird": `styles__oneThird___Lv1nj`,
	"twoThird": `styles__twoThird___aLE27`,
	"purchaseDate": `styles__purchaseDate___JIGsS`,
	"assetHeader": `styles__assetHeader___uyb0M`,
	"assetLeft": `styles__assetLeft___rw1Qf`,
	"assetRight": `styles__assetRight___mlSiT`,
	"actions": `styles__actions___gCOVt ${___CSS_LOADER_ICSS_IMPORT_0___.locals["card"]}`,
	"actionButton": `styles__actionButton___GP6rb`,
	"editButton": `styles__editButton___nyYFY styles__actionButton___GP6rb`,
	"transactionButton": `styles__transactionButton___Tf1R4 styles__editButton___nyYFY styles__actionButton___GP6rb`,
	"statementButton": `styles__statementButton___yGrTc styles__editButton___nyYFY styles__actionButton___GP6rb`,
	"editSubaccountButton": `styles__editSubaccountButton___CzScG styles__editButton___nyYFY styles__actionButton___GP6rb`,
	"table": `styles__table___aC8nW`,
	"section": `styles__section___MIsnV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___uOrxy ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionNoMargin"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionNoMargin"]}`,
	"buttons": `styles__buttons___sLIyW ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"spacer": `styles__spacer___e99JX`,
	"collapseRef": `styles__collapseRef___Tb1H7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["collapseRef"]}`,
	"collapseIcon": `styles__collapseIcon___hpmXF`,
	"leaveNoteIcon": `styles__leaveNoteIcon___SVfOZ`,
	"title": `styles__title___i1M3s`,
	"titleSection": `styles__titleSection___f5CyW ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["row"]}`,
	"name": `styles__name___TDNSE`,
	"noName": `styles__noName___wm1gZ`,
	"cardMarginBot": `styles__cardMarginBot___eGTVX ${___CSS_LOADER_ICSS_IMPORT_0___.locals["cardMarginBot"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["cardMarginBot"]}`,
	"removeBtn": `styles__removeBtn___EzcZL ${___CSS_LOADER_ICSS_IMPORT_0___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___IHzvD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"docsWrapper": `styles__docsWrapper___rGAH4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["flexColumn"]}`,
	"otherDocsRow": `styles__otherDocsRow___l_u5K`,
	"remove": `styles__remove___pdsxJ`,
	"noDocResults": `styles__noDocResults___HMzJj styles__sectionNoMargin___uOrxy ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionNoMargin"]}`,
	"sectionTitle": `styles__sectionTitle___jQFoz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"singleLine": `styles__singleLine___Yop6o`,
	"label": `styles__label___sMwdY`,
	"logSection": `styles__logSection___nUAqa`
};
export default ___CSS_LOADER_EXPORT___;
